import { Component } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { AuthService } from '../auth.service';
import { Title } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-mecontact',
  standalone: true,
  imports: [ReactiveFormsModule, FormsModule, CommonModule],
  templateUrl: './mecontact.component.html',
  styleUrl: './mecontact.component.css'
})
export class MecontactComponent {
  contactForm!: FormGroup;
  message: string | undefined;

  constructor(
    private titleService: Title,
    private fb: FormBuilder,
    private authService: AuthService
  ) {
    this.contactForm = this.fb.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      subject: ['', Validators.required]
    });
  }
  onSubmit(): void {
    if (this.contactForm.valid) {
      this.authService.submitContactForm(this.contactForm.value).subscribe(
        response => {
          this.message = 'Votre message a été envoyé avec succès!';
          this.contactForm.reset();
        },
        error => {
          console.error('Erreur lors de la soumission du formulaire de contact', error);
          this.message = 'Une erreur est survenue. Veuillez réessayer plus tard.';
        }
      );
    }
  }
}
